.fab {
	pointer-events: auto;
	display: inline-flex;
	align-items: center;
	gap: var(--space-1);
	padding: var(--space-3) var(--space-4);
	background: var(--accent-sage);
	color: #fff;
	border: none;
	border-radius: 999px;
	font: inherit;
	font-weight: 600;
	cursor: pointer;
	box-shadow: 0 4px 12px rgb(0 0 0 / 0.18);
}

.fab:hover:not(:disabled) {
	background: color-mix(in srgb, var(--accent-sage) 90%, black);
}

.fab:disabled {
	background: var(--ink-muted);
	opacity: 0.5;
	box-shadow: none;
	cursor: not-allowed;
}
